import { render } from "./ActWizardBar.vue?vue&type=template&id=1bd1cc9c"
import script from "./ActWizardBar.vue?vue&type=script&lang=js"
export * from "./ActWizardBar.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__